import EthereumService from '@/services/ethereum'
export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }

  async connectToDefaultAddress () {
    const wallets = await this.getWallets()
    if (wallets.length) {
      this.store.dispatch('setWallets', wallets)
      this.store.dispatch('setIsWalletConnected', true)
    }
    return wallets
  }
}



// WEBPACK FOOTER //
// ./src/features/WalletConnector/service.js